// @flow
import * as React from 'react';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { injectIntl, IntlShape } from 'react-intl';
import StyledFormCheckmark from 'esm-web-pro/components/layout/sidePanel/icons/StyledFormCheckmark';
import { FormClose } from 'grommet-icons';
import point11Messages from 'esm-web-pro/messages/points11Messages';
import { point12Messages } from 'esm-web-pro/messages/points12Messages';
import points14Messages from 'esm-web-pro/messages/points14Messages';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';

type Props = {
    point14: Object,
    url: string,
    intl: IntlShape,
    onView: Function,
}

const Point14Attributes = (props: Props) => {
    const {
        point14, url, intl: { formatMessage }, onView,
    } = props;
    const {
        container, attenuation, container: { container: point11 }, number,
    } = point14;

    const containerName = container.type === 'switch' ? container.oss_switch_name
        : `${formatMessage(point12Messages[container.type])} ${container.sequence}`;

    const containerMultiValue = [
        {
            value: `${formatMessage(point11Messages[point11.type])} ${
                point11.type === 'pop' && point11.alias
                    ? point11.alias
                    : point11.sequence
            }`,
            link: `${url.split('/layer')[0]}/layer/${point11.type}/${point11.identity}`,
        },
    ];

    if ((container.type === 'switch' || container.type === 'odf') && container.rack) {
        containerMultiValue.push({
            value: `${formatMessage(point12Messages.rack)} ${container.rack.sequence}`,
            link: `${url.split('/layer')[0]}/layer/rack/${container.rack.identity}`,
        });
    }

    containerMultiValue.push({
        value: containerName,
        link: `${url.split('/layer')[0]}/layer/${container.type}/${container.identity}`,
    });

    const attributes = [
        {
            label: formatMessage(attributeMessages.ref),
            value: point14.ref,
            onClick: onView,
        },
        {
            label: formatMessage(attributeMessages.container),
            multiValue: containerMultiValue,
            separator: ', ',
        },
        {
            label: formatMessage(attributeMessages.attenuation),
            value: `${attenuation}`,
        },
    ];

    if (point14.type === 'splice') {
        attributes.push({
            label: formatMessage(points14Messages.isFactory),
            value: point14.is_factory ? <StyledFormCheckmark /> : <FormClose />,
        });
    }

    if (point14.type === 'opticalodfport' && number) {
        attributes.push({
            label: formatMessage(attributeMessages.number),
            value: `${number}`,
        });
    }

    return <Attributes attributes={attributes} />;
};

export default injectIntl(Point14Attributes);
